import notify from "../components/common/notify";

// Function to handle changes in an image input
const handleCropImgChange = (e, setImage, setShowModal = () => {}) => {
  // Prevent the default behavior of the event
  e.preventDefault();

  try {
    let files;

    // Check if the dataTransfer property is available in the event (e.g., for drag-and-drop)
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      // Otherwise, use the target property (e.g., for regular file input)
      files = e.target.files;
    }

    // Create a new FileReader to read the contents of the selected file
    const reader = new FileReader();

    // Set up a callback for when the file is loaded
    reader.onload = () => {
      // Set the image using the loaded result (base64-encoded image data)
      setImage(reader.result);
    };

    // Read the contents of the first file as a data URL
    reader.readAsDataURL(files[0]);

    // Show the modal (if provided)
    setShowModal(true);
  } catch (error) {
    // Handle any errors that occur during the process

    // If there's a specific error message, show it using the notify function
    if (error?.message) {
      notify(error?.message, "error");
    }

    // Show a generic error message if no specific message is available
    notify("Something Wrong!", "error");
  }
};

// Export the handleCropImgChange function as the default export
export default handleCropImgChange;
